/**
 * One-shot flash messages surfaced after a redirect.
 *
 * Signal-based so a route (e.g. LoginRoute after an auto-link) can set it,
 * navigate, and the destination shell can render it once and clear itself.
 * Not persisted; a page reload drops the flash.
 */

import { signal } from '@preact/signals';

export type FlashKind = 'linked-google' | 'checkout-ok' | 'checkout-canceled';

export interface Flash {
  kind: FlashKind;
  message: string;
}

export const flash = signal<Flash | null>(null);

export function setFlash(f: Flash): void {
  flash.value = f;
}

export function clearFlash(): void {
  flash.value = null;
}
